import { helpers, zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

function hhmm(nullish: boolean = false) {
    const obj = z.string().refine(
        value => {
            if (!value && nullish) return true
            const [hours, minutes] = value.split(':')
            return Number(hours) < 24 && Number(minutes) < 60
        },
        { message: 'O campo deve seguir o formato HH:mm' },
    )

    if (nullish) return obj.nullish()

    return obj
}

export const createEmpresaSchema = zod.EmpresaSchema.partial({
    id: true,
    clienteId: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    layoutFolha: true,
    tipoDescontoDSR: true,
    atrasoDescontoDSR: true,
}).extend({
    cnpj: z.coerce
        .string()
        .trim()
        .transform(value => value.replace(/\D/g, ''))
        .refine(v => helpers.isDocumentoEmpresaValido(v), 'Documento inválido'),
    cpfResponsavel: z.coerce
        .string()
        .trim()
        .transform(value => value.replace(/\D/g, ''))
        .refine(v => helpers.isCPF(v), 'CPF inválido'),
    uf: z.coerce
        .string()
        .refine(value => value.length === 2, { message: 'Obrigatório' }),
    telefone: z.coerce.string().trim().optional(),
    celular: z.coerce.string().trim().optional(),
    Cidade: z.object({
        ibge: z.coerce
            .number({ message: 'Obrigatório' })
            .int({ message: 'Obrigatório' })
            .positive({ message: 'Obrigatório' }),
    }),
    diasRescisao: z.coerce.number().int().min(1),
    layoutFolha: z.string().optional(),
    tipoDescontoDSR: z.string().optional(),
    atrasoDescontoDSR: hhmm(true),
    mensagemAniversario: z.string().trim().max(250).optional(),
    justificativaPadraoRegistro: z
        .string()
        .trim()
        .max(190)
        .optional()
        .nullish()
        .transform(v => v || null),
    horarioInicioAdicionalNoturno: hhmm(),
    horarioFimAdicionalNoturno: hhmm(),
    horarioEncerramentoHorarioNoturno: hhmm(true),
    diaInicioPonto: z.coerce.number().int().min(1).max(31),
})

export type CreateEmpresaInput = z.infer<typeof createEmpresaSchema>

export const updateEmpresaSchema = createEmpresaSchema
    .required({
        id: true,
        clienteId: true,
        cpfResponsavel: true,
    })
    .omit({
        createdAt: true,
        updatedAt: true,
    })

export type Empresa = z.infer<typeof updateEmpresaSchema> & {
    TrocaInicioPonto: z.infer<typeof zod.TrocaInicioPontoSchema>[]
} & {
    Cidade?: z.infer<typeof zod.CidadeSchema>
}

export const empresas = new ApiService<CreateEmpresaInput, Empresa>('empresas')
